"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.BookingButton = void 0;
var _react = _interopRequireDefault(require("react"));
var _intl = require("@kyruus/intl");
var _providerComponents = require("@kyruus/provider-components");
var _styles = require("../../styles");
var _booking = require("../../../../lib/booking");
var _globals = require("../../../../lib/constants/globals");
var _messages = _interopRequireDefault(require("../../../../lib/constants/messages"));
const BookingButton = exports.BookingButton = (0, _intl.injectIntl)(_ref => {
  let {
    provider,
    modalDisplay,
    bookingCallback,
    track,
    intl,
    disabled = false
  } = _ref;
  const handleClick = e => {
    track(_globals.LOGGING.MESSAGE.REQUEST_APPOINTMENT, {
      button_location: 'search_results',
      cta: 'primary'
    });
    bookingCallback(e);
  };
  const virtualCare = (0, _booking.isBookVirtualCare)(provider, modalDisplay);

  // Get the appropriate message and label
  const buttonMessage = virtualCare ? _messages.default.virtualcarebutton : _messages.default.ctabutton;
  const ariaLabelMessage = virtualCare ? _messages.default.ariaVirtualCareButton : _messages.default.ariaBookButton;
  return /*#__PURE__*/_react.default.createElement(_styles.BookButton, {
    type: "button",
    mode: "primary",
    onClick: handleClick,
    disabled: disabled || (0, _booking.isBookingDisabled)(provider),
    "aria-label": intl.formatMessage(ariaLabelMessage, {
      name: (0, _providerComponents.getProviderDisplayName)(provider)
    })
  }, /*#__PURE__*/_react.default.createElement(_intl.FormattedMessage, buttonMessage, message => /*#__PURE__*/_react.default.createElement("span", {
    "data-provider-id": provider.id
  }, message)));
});